import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Table from "../../../Components/Tenants/Details/LedgerTable";
import {
  BoxHead,
  DownloadBtn,
  Underline,
} from "../../../Components/Styles/PageStyles";

import { useSelector } from "react-redux";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../../Config";
import Loading from "../../../Components/Loading";
import NotFoundModel from "../../../Components/NotFoundModel";
import { MdOutlineChevronRight } from "react-icons/md";
import { toast } from "react-toastify";

const Ledger = ({ tenantId, e }) => {
  const user = useSelector((state) => state.UserReducer.user);
  const [ledgerData, setLedgerData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [reportUrl, setReportUrl] = useState();

  let query = `&pageNum=1&m=1&y=2026`;
  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/ledger/list/client/${tenantId}/?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setLedgerData(res?.data?.ledger);
      setApiData(res?.data);
    }
  };

  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate();
  }, []);

  useEffect(() => {
    if (!reportUrl) return;

    window.open(reportUrl, '_blank', 'noopener,noreferrer');

    setReportUrl(null);
  }, [reportUrl]);

  const downloadFunction = async (values) => {
    let query = `&e=${e}`;
    const response = await axios.get(
      `${Config.apiUrl}/ledger/download/${tenantId}?${query}`,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const onDownloadSuccess = (res) => {

    if (res.isSuccess === false) {
      toast.error(res.msg || "No data found for the selected date range");
    } else if (res.reportUrl === false) {
      toast.error("No data found for the selected date range");
    } else {
      setReportUrl(res.link);
      toast.success(res.msg || "Report generated successfully");
    }
  };

  const onDownloadError = (res) => {
    toast.error(res.message || "Failed to download report");
  };

  const {
    mutate: downloadReport,
    isLoading: isDownloading,
  } = useMutation(downloadFunction, {
    onSuccess: onDownloadSuccess,
    onError: onDownloadError,
  });

  return (
    <Wrapper>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Ledger
          <Underline />
        </BoxTitle>
        <DownloadBtn type="button" onClick={() => downloadReport()}>
          {isDownloading ? "Downloading..." : "Download"}
        </DownloadBtn>
      </BoxHead>

      {!error && !isLoading && apiData && (
        <>
          <ScrollCard style={{ scrollBehavior: "smooth", }}>
            <Card>
              <Value>
                {apiData?.totalCollection || 0}
              </Value>
              <Label>
                {"Total Dues"}
                <MdOutlineChevronRight className="text-gray-300" size={24} />
              </Label>
            </Card>
            <Card>
              <Value>
                {apiData?.totalReceived || 0}
              </Value>
              <Label>
                {"Total Collection"}
                <MdOutlineChevronRight className="text-gray-300" size={24} />
              </Label>
            </Card>
            <Card>
              <Value>
                {apiData?.totalSecurityReceived || 0}
              </Value>
              <Label>
                {"Total Security Recd"}
                <MdOutlineChevronRight className="text-gray-300" size={24} />
              </Label>
            </Card>
            {apiData?.totalAdjustedFromSecurity > 0 &&
              <>
                <Card>
                  <Value>
                    {apiData?.totalAdjustedFromSecurity || 0}
                  </Value>
                  <Label>
                    {"Security Adjusted"}
                    <MdOutlineChevronRight className="text-gray-300" size={24} />
                  </Label>
                </Card>
                <Card>
                  <Value>
                    {(apiData?.totalSecurityReceived || 0) - (apiData?.totalAdjustedFromSecurity || 0) - (apiData?.refundedAmount || 0)}
                  </Value>
                  <Label>
                    {"Security in Hand"}
                    <MdOutlineChevronRight className="text-gray-300" size={24} />
                  </Label>
                </Card>
              </>
            }
          </ScrollCard>
          <TableWrapper>
            <Table apiData={error ? [] : ledgerData} />
            {(error || (ledgerData && ledgerData.length === 0)) && !isLoading && <NotFoundModel />}
          </TableWrapper>
        </>
      )}
      {/* </FilterTableWrapper> */}

      {/* {error && !isLoading && <NotFoundModel />} */}
      {(isLoading || isRefetching) && <Loading />}
    </Wrapper>
  );
};

const Wrapper = tw.div`space-y-4 mt-2`;
const TableWrapper = tw.h1`my-8 border bg-white rounded-md`;
export const BoxTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg  text-black font-semibold  space-x-2 items-center  mb-5  rounded-md `;
const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
const Value = tw.p`
  text-xl sm:text-2xl font-bold  text-black`;
const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md hover:shadow-sm hover:shadow-primary-color}`;

export default Ledger;
